import { Alert } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export default function InfoMessage(props: any) {
    const alertStyle = {
        backgroundColor: "var(--card)",
        color: "var(--link)",
        fontStyle: "italic",
        paddingLeft: 0,
        marginbottom: 2
    };

    const iconStyle = {
        backgroundColor: "var(--card)",
        color: "var(--link)"
    };

    return (
        <Alert
            icon={<InfoIcon sx={iconStyle} />}
            severity="info"
            sx={alertStyle}>
            {props.message}
        </Alert>
    );
}
